import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Aggressively unregister ALL service workers and purge caches on every load
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
}
if ("caches" in window) {
  caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
}

// Clear stale auth if token is older than 4 hours
const tokenTs = parseInt(localStorage.getItem("token_ts") || "0", 10);
if (tokenTs && Date.now() - tokenTs > 4 * 60 * 60 * 1000) {
  localStorage.removeItem("token");
  localStorage.removeItem("token_ts");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
